import type { ServerStateCardProps } from './Types'
import { Badge } from '@heroui/badge'
import { Card, CardBody } from '@heroui/card'
import { Skeleton } from '@heroui/react'
import cn from 'lib/utils/cn'

const BADGE_CLASSNAMES = {
  base: "shrink-0 grow-0 w-full md:w-auto",
  badge: "left-0",
}

const BADGE_SKELETON_CLASSNAMES = {
  ...BADGE_CLASSNAMES,
  base: cn(BADGE_CLASSNAMES.base, "md:w-1/3"),
}

// serverStateSummary: {
//   maxPlayers: 10,
//   onlinePlayers: 0,
//   version: '1.21.3-81-da71382 (MC: 1.21.3)',
//   bukkitVersion: '1.21.3-R0.1-SNAPSHOT',
//   uptime: 323328,
//   usedMemoryPercentage: 0.6890749409794807
// }
export default function ServerStateCard({
  serverStateSummary,
}: Readonly<ServerStateCardProps>) {
  return serverStateSummary instanceof Error ? (
    <Badge color="danger" content="" placement="top-left" shape="circle" classNames={BADGE_CLASSNAMES}>
      <Card className="w-full">
        <CardBody>
          <p>Server error</p>
          <p className="text-xs text-foreground/50">Server könnte offline sein (&quot;{serverStateSummary.message}&quot;)</p>
        </CardBody>
      </Card>
    </Badge>
  ) : (
    <Badge color="success" content="" placement="top-left" shape="circle" classNames={BADGE_CLASSNAMES}>
      <Card className="w-full">
        <CardBody>
          <div className="flex flex-row items-center justify-between gap-2 mb-2">
            <p>Server online</p>
            <p>Spieler: {serverStateSummary.onlinePlayers}/{serverStateSummary.maxPlayers}</p>
          </div>
          <p className="text-xs text-foreground/50">Uptime: ~{Math.floor(serverStateSummary.uptime / 60 / 60)}h</p>
          <p className="text-xs text-foreground/50">Memory: ~{Math.round((serverStateSummary.usedMemoryPercentage || 0) * 100)}% free (of {serverStateSummary.memoryTotal / 1024 / 1024 / 1024} GB)</p>
          <p className="text-xs text-foreground/50">{serverStateSummary.version} / {serverStateSummary.bukkitVersion}</p>
        </CardBody>
      </Card>
    </Badge>
  )
}

export function ServerStateCardSkeleton() {
  return (
    <Badge color="danger" content="" placement="top-left" shape="circle" classNames={BADGE_SKELETON_CLASSNAMES}>
      <Card className="w-full">
        <CardBody>
          <Skeleton className="w-full h-10 rounded-md" />
        </CardBody>
      </Card>
    </Badge>
  )
}
